import {
  initialState,
  Actions,
  State,
  DELETE_PERIODIC_CHECK,
  DELETE_PERIODIC_CHECK_SUCCESS,
  DELETE_PERIODIC_CHECK_ERROR,
  RESET_DELETE_PERIODIC_CHECK,
} from '../../types/periodic-check/delete'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_PERIODIC_CHECK:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case DELETE_PERIODIC_CHECK_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case DELETE_PERIODIC_CHECK_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_DELETE_PERIODIC_CHECK:
      return initialState
    default:
      return state
  }
}

export default reducers
